import { addStyle, addAttribute } from 'dom-helper';
import GwiApi from 'gwi-api';
import URLBuilder from 'url-builder';
import iFrameBuilder from './iframe-builder';
import ENV from '../config/env';

export default class WidgetV2IframeBuilder extends iFrameBuilder {

  static async getUrl(brickConfig) {
    const apiKey = brickConfig.apiKey;
    const api = new GwiApi(apiKey, null, ENV.gwiHost);
    const watchableTypeLowerCase = brickConfig.watchableType.toLowerCase();
    let url;

    if (['season', 'episode'].includes(watchableTypeLowerCase)) {
      const response = await api.getWatchableMetadata(
          brickConfig.watchableId,
          brickConfig.watchableType,
      );

      const watchable = response[watchableTypeLowerCase];
      url = watchable.url;
    } else {
      url = `/watch/${brickConfig.watchableType}s/${brickConfig.watchableId}`;
    }

    return URLBuilder.buildWidgetV2Url(ENV.websiteHost, url, brickConfig);
  }

  static styleHolder(holder, brickConfig) {
    addStyle(holder, {
      height: brickConfig.height || '100%',
      width: brickConfig.width || '100%',
    });

    return holder;
  }

  static styleIframe(iframe) {
    addAttribute(iframe, 'scrolling', 'yes');
    return iframe;
  }
}



// WEBPACK FOOTER //
// ./src/utils/widget-v2-iframe-builder.js